// Shared across every proposal: short video reviews from past clients, shown in "Why sellers choose Adam"
// under "Hear it from clients". Edit here once; every client's page picks it up. Order here is display order.
//
// Each entry:
//   id       file-safe key, also used for test ids
//   name     the client's name as shown under the card
//   caption  one line under the name (what they did, and the year)
//   file     local copy in /public/videos/<file>; played first
//   poster   still frame (about 1 second in) in /public/images/<poster>; shown on the card and before play
//   remote   the original link; used only if the local file is missing or fails to load
//
// Posters are made with ffmpeg from the local file, e.g.
//   ffmpeg -ss 1 -i public/videos/reviews/<id>.mp4 -frames:v 1 -vf scale=640:-2 -c:v libwebp -quality 78 public/images/reviews/<id>-poster.webp

export const videoReviews = [
  {
    id: "carl-larson",
    name: "Carl Larson",
    caption: "Sold a home in Mountlake Terrace, 2026",
    file: "reviews/carl-larson.mp4",
    poster: "reviews/carl-larson-poster.webp",
    remote: "https://d22w406flwlypy.cloudfront.net/seats/65fb504402433aad63b296b6/69e3e249e9332b25cb1dc0c0/video/mp4-portrait-if7KRNOqBV.mp4",
  },
  {
    id: "heng-liu",
    name: "Heng Liu",
    caption: "Bought a home, 2025",
    file: "reviews/heng-liu.mp4",
    poster: "reviews/heng-liu-poster.webp",
    remote: "https://d22w406flwlypy.cloudfront.net/seats/65fb504402433aad63b296b6/684362e003c1bafff699e59b/video/mp4-portrait-TJifarIxuQ.mp4",
  },
  {
    id: "conor-meagher",
    name: "Conor Meagher",
    caption: "2025",
    file: "reviews/conor-meagher.mp4",
    poster: "reviews/conor-meagher-poster.webp",
    remote: "https://d22w406flwlypy.cloudfront.net/seats/65fb504402433aad63b296b6/680d30b4dd7104bd7f88d82f/video/mp4-portrait-cRKraf4g7w.mp4",
  },
  {
    id: "mukund-gorla",
    name: "Mukund Gorla",
    caption: "2024",
    file: "reviews/mukund-gorla.mp4",
    poster: "reviews/mukund-gorla-poster.webp",
    remote: "https://d22w406flwlypy.cloudfront.net/seats/65fb504402433aad63b296b6/672174fee3629bc0badb9754/video/mp4-portrait-8MY2Cf727h.mp4",
  },
  {
    id: "charlene",
    name: "Charlene",
    caption: "2024",
    file: "reviews/charlene.mp4",
    poster: "reviews/charlene-poster.webp",
    remote: "https://d22w406flwlypy.cloudfront.net/seats/65fb504402433aad63b296b6/668f7e1e3a4ad484437a0207/video/mp4-portrait-UFJ2Yzp61T.mp4",
  },
  {
    id: "kaixin-ma",
    name: "Kaixin Ma",
    caption: "2024",
    file: "reviews/kaixin-ma.mp4",
    poster: "reviews/kaixin-ma-poster.webp",
    remote: "https://d22w406flwlypy.cloudfront.net/seats/65fb504402433aad63b296b6/668f7a54460bfef0ced0dfbf/video/mp4-portrait-vX7kM4kQb9.mp4",
  },
];
